import { Components, Theme } from '@mui/material/styles';
import colorPalettes from '../../../themes/custom/colorPalettes';

export const inlineAlertTheme: Components<Theme>['MuiAlert'] = {
  styleOverrides: {
    root: {
      fontFamily: 'Archivo',
      borderRadius: '6px',
    },
    standardError: {
      backgroundColor: colorPalettes.State['error-background'],
      border: `2px solid ${colorPalettes.State['error-pressed']}`,
      '& .MuiAlert-icon': {
        color: colorPalettes.State['error-pressed'],
      },
    },
    standardWarning: {
      backgroundColor: colorPalettes.State['warning-background'],
      border: `2px solid ${colorPalettes.State['warning-pressed']}`,
      '& .MuiAlert-icon': {
        color: colorPalettes.State['warning-pressed'],
      },
    },
    standardSuccess: {
      backgroundColor: colorPalettes.State['success-background'],
      border: `2px solid ${colorPalettes.State['success-pressed']}`,
      '& .MuiAlert-icon': {
        color: colorPalettes.State['success-pressed'],
      },
    },
    standardInfo: {
      backgroundColor: colorPalettes.State['info-background'],
      border: `2px solid ${colorPalettes.State['info-pressed']}`,
      '& .MuiAlert-icon': {
        color: colorPalettes.State['info-pressed'],
      },
    },
  },
  variants: [
    {
      props: { severity: 'error' },
      style: {
        '& .MuiAlert-message': {
          color: colorPalettes.M3.black,
          fontWeight: 400,
          lineHeight: '24px',
        },
      },
    },
  ],
};
